export default function CandleFlame({ size = 220, testid = "hero-candle-flame-animation" }) {
  return (
    <div data-testid={testid} className="relative" style={{ width: size, height: size * 1.4 }} aria-hidden="true">
      {/* Glow aura */}
      <div className="absolute inset-0 glow-pulse" style={{
        background: "radial-gradient(circle at 50% 40%, rgba(255,193,7,0.55), rgba(255,120,40,0.15) 40%, transparent 65%)",
        filter: "blur(18px)",
      }} />
      {/* Candle body */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 rounded-b-lg rounded-t-md shadow-inner"
        style={{
          width: size * 0.55, height: size * 0.6,
          background: "linear-gradient(180deg, #efe1cf 0%, #e5d1b4 30%, #d2b48c 100%)",
          boxShadow: "inset 0 8px 22px rgba(140,94,60,0.35), 0 20px 30px -12px rgba(60,30,10,0.25)",
        }} />
      {/* Wick */}
      <div className="absolute left-1/2 -translate-x-1/2" style={{
        bottom: size * 0.6 - 4, width: 2, height: size * 0.08,
        background: "#2A1E17", borderRadius: 2,
      }} />
      {/* Flame */}
      <svg className="absolute left-1/2 -translate-x-1/2 flame-animate"
        style={{ bottom: size * 0.6 + size * 0.06 - 2 }}
        width={size * 0.22} height={size * 0.4} viewBox="0 0 40 70">
        <defs>
          <radialGradient id="flameG" cx="50%" cy="70%" r="60%">
            <stop offset="0%" stopColor="#FFE79A" />
            <stop offset="45%" stopColor="#FFC107" />
            <stop offset="80%" stopColor="#F97316" />
            <stop offset="100%" stopColor="#C86D51" stopOpacity="0.9" />
          </radialGradient>
        </defs>
        <path d="M20 3 C 8 22, 4 40, 20 66 C 36 40, 32 22, 20 3 Z" fill="url(#flameG)" />
        <ellipse cx="20" cy="52" rx="6" ry="10" fill="#3E2A1C" opacity="0.55" />
      </svg>
    </div>
  );
}
